/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import MusicCard from '@eternal/Components/Card/MusicCard';
import MidContainer from '@eternal/Components/Layout/MidContainer';

/* Services */

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const MusicIcons = ({ sectionContent, region, lang }) => {
  // console.log('MusicIcons', sectionContent);
  return (
    <Box w="100%" bg="#fff" h="auto">
      <MidContainer
        w={{ base: 670, xl: 1240 }}
        px="20px"
        py={{ base: '50px', md: '30px' }}
      >
        <Flex
          flexWrap={{ base: 'wrap', xl: 'nowrap' }}
          justifyContent="center"
          alignItems="center"
          gap={30}
        >
          {sectionContent[0]?.cards?.map(card => (
            <MusicCard card={card} lang={lang} region={region} key={nanoid()} />
          ))}
        </Flex>
      </MidContainer>
    </Box>
  );
};

export default MusicIcons;
